import WithApolloProvider from './WithApolloProvider';

export default WithApolloProvider;
